import React, { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import api, { resolveImg } from "../../../lib/api";
import { logger } from "../../../lib/logger";
import { toast } from "sonner";

const isVideo = (url) => /\.(mp4|webm|mov)(\?|$)/i.test(url);

const Thumb = ({ url, box, onRemove }) => (
  <div className={`relative ${box} bg-[#0B0A08] border border-[#262421] overflow-hidden`}>
    {isVideo(url) ? <video src={resolveImg(url)} className="w-full h-full object-cover" muted /> : <img src={resolveImg(url)} alt="" className="w-full h-full object-cover" />}
    <button onClick={onRemove} className="absolute -top-2 -end-2 bg-[#c88] text-[#0B0A08] w-5 h-5 flex items-center justify-center"><X size={12} /></button>
  </div>
);

// Upload grid for a list of media URLs (product images or journey media).
export const MediaUploader = ({ items, onChange, accept, box, testId, label, okText, failText }) => {
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange([...items, data.url]);
      toast.success(okText);
    } catch (err) {
      logger.error("upload failed", err);
      toast.error(failText);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap gap-3 mt-2">
      {items.map((url) => <Thumb key={url} url={url} box={box} onRemove={() => onChange(items.filter((u) => u !== url))} />)}
      <button onClick={() => ref.current.click()} data-testid={testId} className={`${box} border border-dashed border-[#262421] flex flex-col items-center justify-center gap-1 text-[#8A857D] hover:border-[#C49A6C] text-[10px] uppercase tracking-widest`}>
        {busy ? "…" : <><Upload size={18} />{label}</>}
      </button>
      <input ref={ref} type="file" accept={accept} onChange={upload} className="hidden" />
    </div>
  );
};
